const prsButtonPreThemes = {
  regular: {
    depth: '0',
  },
  default: {
    backgroundColor: '#0600B4',
  },
};

export const prsButtonTheme = {
  regular: {
    /* border-color: ???? */
    backgroundColor: '#FFFFFF',
    hoverBackgroundColor: '#00BCFF',
    backgroundImage: 'none,url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'a\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'1.34\' numOctaves=\'4\' stitchTiles=\'stitch\'%3E%3C/feTurbulence%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23a)\' opacity=\'0.2\'%3E%3C/rect%3E%3C/svg%3E")',
    hoverColor: '#000',
    color: '#0600B4',
    borderWidth: '1px',
    borderRadius: '0.25em',
    padding: '1rem',
    height: '2.5rem',
    baseContentColor: '#1D1B26',
    buttonShadow: `0 3px 2px -2px color-mix(in oklab,#0600B4calc(${prsButtonPreThemes.regular.depth}*30%),#0000),0 4px 3px -2px color-mix(in oklab,var(--btn-bg)calc(${prsButtonPreThemes.regular.depth}*30%),#0000)`,
    depth: prsButtonPreThemes.regular.depth,
    noiseSize: '0',
    fontSize: '0.875rem',
    fontFamily: '"Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  },
  default: {
    backgroundColor: prsButtonPreThemes.default.backgroundColor,
    borderColor: `color-mix(in oklab,${prsButtonPreThemes.default.backgroundColor},#000 calc(0*5%))`,
    hoverColor: '#000',
    color: '#FFFFFF',
    disabledBackgroundColor: '#c8c8c8',
    disabledBorderColor: '#c8c8c8',
    disabledColor: '#FFFFFF',
  },
};
